module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('form', {
    staticClass: "create-cat",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createCat()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "name": "title",
      "placeholder": "Your Cats Name"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("+")])]), _vm._v(" "), (_vm.foundBadWord) ? _c('div', {
    staticClass: "bad-word"
  }, [_vm._v("\n    For shame, detected the word '" + _vm._s(_vm.badWord) + "' which isn't allowed.\n    "), _c('br'), _c('small', [_vm._v("Cat's have feelings too 😿")])]) : _vm._e(), _vm._v(" "), (_vm.stringTooLong) ? _c('div', {
    staticClass: "bad-word"
  }, [_vm._v("\n    Only names 25 characters or less can be accepted\n  ")]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "social"
  }, [_c('div', {
    staticClass: "container fb-like",
    staticStyle: {
      "padding-bottom": "0.5%"
    },
    attrs: {
      "data-href": "https://uniqitty.com",
      "data-layout": "button_count",
      "data-action": "like",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter-share-button",
    attrs: {
      "href": "https://twitter.com/share",
      "data-text": "Check out Uniqitty to see if your cat name is unique!",
      "data-url": "https://uniqitty.com",
      "data-hashtags": "Uniqitty",
      "data-show-count": "false"
    }
  }, [_vm._v("Tweet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72a0122b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cats/Create.vue
// module id = 129
// module chunks = 2